var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgB2C(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 200,
    viewBox: "0 0 420 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_579",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 420,
    height: 200
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 420,
    height: 200,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.965 176.475H101.487C98.4689 176.475 96 174.006 96 170.988V63.0527C96 60.0349 98.4689 57.566 101.487 57.566H173.965C176.983 57.566 179.452 60.0349 179.452 63.0527V170.987C179.452 174.005 176.983 176.475 173.965 176.475Z",
    fill: "#2D90DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.057 67.3483H102.368V159.366H168.057V67.3483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.482 67.1686C162.372 73.261 160.699 79.2616 158.467 85.1032C152.318 101.189 142.55 116.246 131.103 129.615C125.818 135.787 119.81 141.437 113.02 146.216C109.732 148.529 106.204 150.606 102.459 152.206V166.872H173.496V67.1686H163.482Z",
    fill: "#E3F2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.861 66.6767C144.832 66.6767 150.483 61.482 150.483 55.0741C150.483 48.6661 144.832 43.4714 137.861 43.4714C130.889 43.4714 125.238 48.6661 125.238 55.0741C125.238 61.482 130.889 66.6767 137.861 66.6767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.101 70.286C163.646 69.094 163.948 67.7872 163.948 66.4184C163.948 60.8881 159.026 56.3627 153.008 56.3627H121.592C115.575 56.3627 110.652 60.8876 110.652 66.4184C110.652 67.7872 110.955 69.094 111.5 70.286H163.101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.831 89.1823H115.003C113.93 89.1823 113.052 88.3045 113.052 87.2313C113.052 86.1582 113.93 85.2804 115.003 85.2804H160.831C161.905 85.2804 162.782 86.1582 162.782 87.2313C162.783 88.3045 161.905 89.1823 160.831 89.1823Z",
    fill: "#7DC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.831 100.332H115.003C113.93 100.332 113.052 99.4541 113.052 98.3809C113.052 97.3077 113.93 96.4299 115.003 96.4299H160.831C161.905 96.4299 162.782 97.3077 162.782 98.3809C162.783 99.4536 161.905 100.332 160.831 100.332Z",
    fill: "#7DC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.831 113.711H115.003C113.93 113.711 113.052 112.833 113.052 111.76C113.052 110.686 113.93 109.809 115.003 109.809H160.831C161.905 109.809 162.782 110.686 162.782 111.76C162.783 112.833 161.905 113.711 160.831 113.711Z",
    fill: "#7DC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.831 127.09H115.003C113.93 127.09 113.052 126.212 113.052 125.139C113.052 124.065 113.93 123.188 115.003 123.188H160.831C161.905 123.188 162.782 124.065 162.782 125.139C162.783 126.212 161.905 127.09 160.831 127.09Z",
    fill: "#7DC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.831 140.468H115.003C113.93 140.468 113.052 139.591 113.052 138.517C113.052 137.444 113.93 136.566 115.003 136.566H160.831C161.905 136.566 162.782 137.444 162.782 138.517C162.783 139.591 161.905 140.468 160.831 140.468Z",
    fill: "#7DC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.831 153.848H115.003C113.93 153.848 113.052 152.97 113.052 151.897C113.052 150.823 113.93 149.946 115.003 149.946H160.831C161.905 149.946 162.782 150.824 162.782 151.897C162.783 152.969 161.905 153.848 160.831 153.848Z",
    fill: "#7DC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.023 57.3667C140.186 57.3667 141.939 55.7554 141.939 53.7677C141.939 51.78 140.186 50.1687 138.023 50.1687C135.861 50.1687 134.107 51.78 134.107 53.7677C134.107 55.7554 135.861 57.3667 138.023 57.3667Z",
    fill: "#283954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.162 67.444C115.162 64.0586 117.801 61.3138 121.056 61.3138H153.704C156.833 61.3138 159.369 63.9515 159.369 67.2049V68.2796",
    stroke: "#2D90DE",
    strokeWidth: 1.6809,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.844 177.658C107.88 177.658 311.024 177.658 311.024 177.658",
    stroke: "#76BDF5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.475 35.0176C144.466 35.0176 145.269 34.2145 145.269 33.2238C145.269 32.2331 144.466 31.4299 143.475 31.4299C142.485 31.4299 141.682 32.2331 141.682 33.2238C141.682 34.2145 142.485 35.0176 143.475 35.0176Z",
    fill: "#F1F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.279 43.389C114.875 43.389 116.169 42.095 116.169 40.4989C116.169 38.9027 114.875 37.6088 113.279 37.6088C111.683 37.6088 110.389 38.9027 110.389 40.4989C110.389 42.095 111.683 43.389 113.279 43.389Z",
    fill: "#F1F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.139 43.8873C154.579 43.8873 154.936 43.5303 154.936 43.09C154.936 42.6497 154.579 42.2927 154.139 42.2927C153.699 42.2927 153.342 42.6497 153.342 43.09C153.342 43.5303 153.699 43.8873 154.139 43.8873Z",
    fill: "#F1F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.218 75.5843C202.484 75.5843 203.511 74.5581 203.511 73.2921C203.511 72.0262 202.484 71 201.218 71C199.953 71 198.926 72.0262 198.926 73.2921C198.926 74.5581 199.953 75.5843 201.218 75.5843Z",
    fill: "#F1F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.017 63.2028C198.512 63.2028 198.913 62.8013 198.913 62.3059C198.913 61.8106 198.512 61.409 198.017 61.409C197.521 61.409 197.12 61.8106 197.12 62.3059C197.12 62.8013 197.521 63.2028 198.017 63.2028Z",
    fill: "#F1F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.205 84.4483C193.59 84.4483 193.903 84.136 193.903 83.7507C193.903 83.3654 193.59 83.0531 193.205 83.0531C192.82 83.0531 192.507 83.3654 192.507 83.7507C192.507 84.136 192.82 84.4483 193.205 84.4483Z",
    fill: "#F1F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.115 73.3781C218.877 73.3781 220.304 71.9504 220.304 70.1891C220.304 68.4278 218.877 67 217.115 67C215.354 67 213.926 68.4278 213.926 70.1891C213.926 71.9504 215.354 73.3781 217.115 73.3781Z",
    fill: "#F1F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.242 67.7057C300.177 67.7057 300.936 66.9471 300.936 66.0115C300.936 65.0758 300.177 64.3173 299.242 64.3173C298.306 64.3173 297.547 65.0758 297.547 66.0115C297.547 66.9471 298.306 67.7057 299.242 67.7057Z",
    fill: "#F1F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.517 81.1823C271.948 81.1823 273.109 80.0222 273.109 78.5911C273.109 77.1601 271.948 76 270.517 76C269.086 76 267.926 77.1601 267.926 78.5911C267.926 80.0222 269.086 81.1823 270.517 81.1823Z",
    fill: "#F1F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.703 92.7814L242.814 114.462",
    stroke: "#F1F7FF",
    strokeWidth: 2.6475,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.835 96.9056H219.116V152.568H279.835V96.9056Z",
    fill: "#F9A41C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M279.835 96.9056H254.021V152.568H279.835V96.9056Z",
    fill: "#E56700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.54 101.39H224.199V110.659H241.54V101.39Z",
    fill: "#F1F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.839 112.751H224.498V117.134H241.839V112.751Z",
    fill: "#34304F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.232 114.462V152.586H264.258L287.133 115.334L210.232 114.462Z",
    stroke: "#F1F7FF",
    strokeWidth: 2.6475,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.12 92.7814L210.231 114.462",
    stroke: "#F1F7FF",
    strokeWidth: 2.6475,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.738 115.191V151.604",
    stroke: "#F1F7FF",
    strokeWidth: 2.6407,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.927 115.221V151.821",
    stroke: "#F1F7FF",
    strokeWidth: 2.6475,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.687 115.439V152.039",
    stroke: "#F1F7FF",
    strokeWidth: 2.6475,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.015 115.657V152.257",
    stroke: "#F1F7FF",
    strokeWidth: 2.6475,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.774 152.475V115.875",
    stroke: "#F1F7FF",
    strokeWidth: 2.6475,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.677 128.075H294.941",
    stroke: "#F1F7FF",
    strokeWidth: 2.6475,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.677 142.671L285.765 142.453",
    stroke: "#F1F7FF",
    strokeWidth: 2.6475,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.46 152.775L276.678 116.082",
    stroke: "#F1F7FF",
    strokeWidth: 2.6475,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.507 93.5118H187.348C186.228 93.5118 185.312 92.5953 185.312 91.4755C185.312 90.3557 186.228 89.4391 187.348 89.4391H233.507C234.626 89.4391 235.543 90.3557 235.543 91.4755C235.543 92.5958 234.627 93.5118 233.507 93.5118Z",
    fill: "#F9A41C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.507 89.4391H217.436C217.681 90.7833 218.024 92.1475 218.474 93.5118H233.507C234.626 93.5118 235.543 92.5953 235.543 91.4755C235.543 90.3557 234.626 89.4391 233.507 89.4391Z",
    fill: "#EB6E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.229 115.191L304.025 115.477L279.835 152.568L254.015 152.257",
    stroke: "#F1F7FF",
    strokeWidth: 2.627,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.216 152.229L294.844 116.338",
    stroke: "#F1F7FF",
    strokeWidth: 2.6407,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.343 176.304C231.672 176.304 234.371 173.605 234.371 170.275C234.371 166.946 231.672 164.246 228.343 164.246C225.013 164.246 222.314 166.946 222.314 170.275C222.314 173.605 225.013 176.304 228.343 176.304Z",
    fill: "#2D90DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.343 173.442C230.092 173.442 231.509 172.024 231.509 170.275C231.509 168.526 230.092 167.109 228.343 167.109C226.594 167.109 225.176 168.526 225.176 170.275C225.176 172.024 226.594 173.442 228.343 173.442Z",
    fill: "#34304F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.44 169.939C226.302 169.518 225.716 168.242 226.137 167.104L229.319 158.51C229.74 157.372 231.015 156.786 232.153 157.208C233.291 157.629 233.878 158.904 233.456 160.042L230.275 168.636C229.854 169.773 228.578 170.36 227.44 169.939Z",
    fill: "#A5D7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.308 149.853H269.766L288.942 119.193L297.258 119.42L278.308 149.853Z",
    fill: "#2D90DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.106 176.499C277.435 176.499 280.134 173.8 280.134 170.471C280.134 167.141 277.435 164.442 274.106 164.442C270.776 164.442 268.077 167.141 268.077 170.471C268.077 173.8 270.776 176.499 274.106 176.499Z",
    fill: "#2D90DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.106 173.409C275.729 173.409 277.044 172.093 277.044 170.47C277.044 168.847 275.729 167.532 274.106 167.532C272.483 167.532 271.167 168.847 271.167 170.47C271.167 172.093 272.483 173.409 274.106 173.409Z",
    fill: "#34304F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.572 169.962H273.376C272.383 169.962 271.571 169.149 271.571 168.157V158.927C271.571 157.935 272.383 157.122 273.376 157.122H273.572C274.565 157.122 275.377 157.935 275.377 158.927V168.157C275.377 169.15 274.565 169.962 273.572 169.962Z",
    fill: "#A5D7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.232 157.814H277.544",
    stroke: "#2D90DE",
    strokeWidth: 3.53,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.536 176.16C215.866 176.16 218.565 173.461 218.565 170.131C218.565 166.802 215.866 164.103 212.536 164.103C209.207 164.103 206.508 166.802 206.508 170.131C206.508 173.461 209.207 176.16 212.536 176.16Z",
    fill: "#2D90DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.537 173.717C214.518 173.717 216.123 172.112 216.123 170.131C216.123 168.151 214.518 166.545 212.537 166.545C210.556 166.545 208.951 168.151 208.951 170.131C208.951 172.112 210.556 173.717 212.537 173.717Z",
    stroke: "white",
    strokeWidth: 1.74,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.312 176.499C263.642 176.499 266.341 173.8 266.341 170.471C266.341 167.141 263.642 164.442 260.312 164.442C256.983 164.442 254.284 167.141 254.284 170.471C254.284 173.8 256.983 176.499 260.312 176.499Z",
    fill: "#2D90DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.634 169.795C210.496 169.374 209.91 168.098 210.331 166.96L213.512 158.367C213.933 157.229 215.209 156.642 216.347 157.064C217.485 157.485 218.071 158.761 217.65 159.898L214.468 168.492C214.047 169.63 212.772 170.216 211.634 169.795Z",
    fill: "#A5D7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.089 173.886C262.07 173.886 263.675 172.28 263.675 170.3C263.675 168.319 262.07 166.713 260.089 166.713C258.109 166.713 256.503 168.319 256.503 170.3C256.503 172.28 258.109 173.886 260.089 173.886Z",
    stroke: "white",
    strokeWidth: 1.74,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.758 169.962H259.603C258.599 169.962 257.777 169.14 257.777 168.137V158.656C257.777 157.652 258.599 156.831 259.603 156.831H259.758C260.762 156.831 261.584 157.652 261.584 158.656V168.137C261.584 169.14 260.762 169.962 259.758 169.962Z",
    fill: "#A5D7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.798 96.9057L264.112 107.22H295.953L285.564 96.8306C285.564 96.8306 252.303 96.9057 253.798 96.9057Z",
    fill: "#FAC119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.328 99.1978C303.768 99.1978 304.125 98.8409 304.125 98.4005C304.125 97.9602 303.768 97.6033 303.328 97.6033C302.887 97.6033 302.53 97.9602 302.53 98.4005C302.53 98.8409 302.887 99.1978 303.328 99.1978Z",
    fill: "#B9D0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.427 149.226C304.362 149.226 305.121 148.468 305.121 147.532C305.121 146.597 304.362 145.838 303.427 145.838C302.491 145.838 301.732 146.597 301.732 147.532C301.732 148.468 302.491 149.226 303.427 149.226Z",
    fill: "#F1F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.495 185C203.477 185 211.568 176.909 211.568 166.927C211.568 156.946 203.477 148.855 193.495 148.855C183.514 148.855 175.423 156.946 175.423 166.927C175.423 176.909 183.514 185 193.495 185Z",
    fill: "#FAC119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.638 166.491L191.162 172.116L202.662 159.289",
    stroke: "white",
    strokeWidth: 5.371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.684 153.611C204.699 153.171 210.896 146.998 211.364 139.985C213.267 146.557 211.25 154.109 206.324 158.858C205.623 155.457 201.152 153.779 197.684 153.611Z",
    fill: "#FAC119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.784 60.137C218.406 60.137 225.394 53.1482 225.394 44.527C225.394 35.9057 218.406 28.9169 209.784 28.9169C201.163 28.9169 194.174 35.9057 194.174 44.527C194.174 53.1482 201.163 60.137 209.784 60.137Z",
    fill: "#FAC119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.784 60.137C218.406 60.137 225.394 53.1482 225.394 44.527C225.394 35.9057 218.406 28.9169 209.784 28.9169C201.163 28.9169 194.174 35.9057 194.174 44.527C194.174 53.1482 201.163 60.137 209.784 60.137Z",
    fill: "#FAC119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.784 56.0039C216.123 56.0039 221.261 50.8655 221.261 44.5269C221.261 38.1884 216.123 33.05 209.784 33.05C203.446 33.05 198.307 38.1884 198.307 44.5269C198.307 50.8655 203.446 56.0039 209.784 56.0039Z",
    fill: "#F9A41C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.792 50.0978C209.029 50.0978 208.292 50.0112 207.582 49.8378C206.871 49.6645 206.286 49.4392 205.827 49.1618L206.815 46.9258C207.248 47.1772 207.729 47.3808 208.258 47.5368C208.795 47.6842 209.315 47.7578 209.818 47.7578C210.112 47.7578 210.342 47.7405 210.507 47.7058C210.68 47.6625 210.806 47.6062 210.884 47.5368C210.962 47.4588 211.001 47.3678 211.001 47.2638C211.001 47.0992 210.91 46.9692 210.728 46.8738C210.546 46.7785 210.303 46.7005 210 46.6398C209.705 46.5705 209.38 46.5012 209.025 46.4318C208.669 46.3538 208.31 46.2542 207.946 46.1328C207.59 46.0115 207.261 45.8512 206.958 45.6518C206.663 45.4525 206.425 45.1925 206.243 44.8718C206.061 44.5425 205.97 44.1352 205.97 43.6498C205.97 43.0865 206.126 42.5752 206.438 42.1158C206.758 41.6478 207.231 41.2752 207.855 40.9978C208.487 40.7205 209.272 40.5818 210.208 40.5818C210.823 40.5818 211.43 40.6468 212.028 40.7768C212.626 40.9068 213.163 41.1062 213.64 41.3748L212.717 43.5978C212.266 43.3725 211.828 43.2035 211.404 43.0908C210.988 42.9782 210.58 42.9218 210.182 42.9218C209.887 42.9218 209.653 42.9478 209.48 42.9998C209.306 43.0518 209.181 43.1212 209.103 43.2078C209.033 43.2945 208.999 43.3898 208.999 43.4938C208.999 43.6498 209.09 43.7755 209.272 43.8708C209.454 43.9575 209.692 44.0312 209.987 44.0918C210.29 44.1525 210.619 44.2175 210.975 44.2868C211.339 44.3562 211.698 44.4515 212.054 44.5728C212.409 44.6942 212.734 44.8545 213.029 45.0538C213.332 45.2532 213.575 45.5132 213.757 45.8338C213.939 46.1545 214.03 46.5532 214.03 47.0298C214.03 47.5845 213.869 48.0958 213.549 48.5638C213.237 49.0232 212.769 49.3958 212.145 49.6818C211.521 49.9592 210.736 50.0978 209.792 50.0978ZM209.168 51.4498V49.7598H211.001V51.4498H209.168ZM209.168 40.9198V39.2298H211.001V40.9198H209.168Z",
    fill: "#E56700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.865 35.1964L200.274 37.8881",
    stroke: "#E88900",
    strokeWidth: 2.2076,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.293 31.7731L202.947 35.2111",
    stroke: "#E88900",
    strokeWidth: 2.2076,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.84 29.7239L206.653 33.671",
    stroke: "#E88900",
    strokeWidth: 2.2076,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.645 54.7397L218.236 52.0485",
    stroke: "#E88900",
    strokeWidth: 2.2076,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.228 57.8719L214.758 54.2989",
    stroke: "#E88900",
    strokeWidth: 2.2076,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.772 59.8533L210.959 55.9062",
    stroke: "#E88900",
    strokeWidth: 2.2076,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.839 21L247.222 23.5293L249.752 24.9127L247.222 26.2961L245.839 28.8254L244.456 26.2961L241.926 24.9127L244.456 23.5293L245.839 21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11_579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.494 203.08L348.309 201.45C348.406 201.257 348.575 201.11 348.78 201.042C348.985 200.973 349.209 200.989 349.402 201.086C349.596 201.183 349.743 201.352 349.811 201.557C349.879 201.762 349.863 201.986 349.766 202.18L348.952 203.809C348.904 203.905 348.838 203.99 348.757 204.06C348.676 204.13 348.582 204.184 348.48 204.218C348.379 204.251 348.272 204.265 348.165 204.257C348.058 204.25 347.954 204.221 347.858 204.173C347.763 204.125 347.677 204.059 347.607 203.978C347.537 203.897 347.484 203.804 347.45 203.702C347.416 203.6 347.402 203.493 347.41 203.387C347.418 203.28 347.446 203.176 347.494 203.08ZM336.815 210.778H337.63C337.846 210.778 338.053 210.692 338.206 210.539C338.359 210.386 338.445 210.179 338.445 209.963C338.445 209.747 338.359 209.54 338.206 209.387C338.053 209.234 337.846 209.148 337.63 209.148H336.815C336.599 209.148 336.392 209.234 336.239 209.387C336.086 209.54 336 209.747 336 209.963C336 210.179 336.086 210.386 336.239 210.539C336.392 210.692 336.599 210.778 336.815 210.778ZM344.963 203.445C345.179 203.445 345.386 203.359 345.539 203.206C345.692 203.053 345.778 202.846 345.778 202.63V201.815C345.778 201.599 345.692 201.392 345.539 201.239C345.386 201.086 345.179 201 344.963 201C344.747 201 344.54 201.086 344.387 201.239C344.234 201.392 344.148 201.599 344.148 201.815V202.63C344.148 202.846 344.234 203.053 344.387 203.206C344.54 203.359 344.747 203.445 344.963 203.445ZM338.08 212.494L336.45 213.309C336.257 213.406 336.11 213.575 336.042 213.78C335.973 213.985 335.989 214.209 336.086 214.402C336.183 214.595 336.352 214.742 336.557 214.811C336.762 214.879 336.986 214.863 337.18 214.766L338.809 213.952C338.905 213.904 338.99 213.837 339.06 213.756C339.13 213.676 339.184 213.582 339.218 213.48C339.251 213.379 339.265 213.272 339.257 213.165C339.25 213.058 339.221 212.954 339.173 212.858C339.125 212.762 339.059 212.677 338.978 212.607C338.897 212.537 338.804 212.483 338.702 212.45C338.6 212.416 338.493 212.402 338.387 212.41C338.28 212.418 338.176 212.446 338.08 212.494ZM351.896 214.113L357.023 211.885C357.324 211.752 357.577 211.531 357.75 211.251C357.922 210.972 358.006 210.646 357.991 210.318C357.975 209.99 357.861 209.674 357.663 209.412C357.464 209.15 357.191 208.954 356.88 208.85L340.575 203.526C340.29 203.433 339.984 203.42 339.692 203.49C339.4 203.56 339.134 203.709 338.921 203.921C338.709 204.133 338.56 204.4 338.49 204.692C338.42 204.984 338.433 205.29 338.526 205.575L343.85 221.88C343.95 222.194 344.145 222.47 344.407 222.671C344.67 222.871 344.988 222.986 345.318 223H345.397C345.713 223.001 346.023 222.909 346.288 222.735C346.553 222.562 346.76 222.314 346.885 222.023L349.114 216.896L354.741 222.522C354.892 222.674 355.072 222.794 355.27 222.876C355.467 222.958 355.679 223 355.893 223C356.107 223 356.319 222.958 356.517 222.876C356.715 222.794 356.895 222.674 357.046 222.522L357.523 222.046C357.674 221.894 357.794 221.715 357.876 221.517C357.958 221.319 358 221.107 358 220.893C358 220.679 357.958 220.467 357.876 220.269C357.794 220.072 357.674 219.892 357.523 219.741L351.896 214.113Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11_579",
    x: 330,
    y: 195,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0568155 0 0 0 0 0.0695606 0 0 0 0 0.184266 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_579"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_579",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2C);
export default __webpack_public_path__ + "static/media/b2c.2a8e6ac2.svg";
export { ForwardRef as ReactComponent };